import VillaCalculatorLayout from './VillaCalculatorLayout';

export default VillaCalculatorLayout;
